/*global cms*/
import axios from 'axios'
import { queryString } from '../helpers';

const getForms = (company = '') => {
	return new Promise((resolve, reject) => {
		return axios.get(`${cms.baseURL}/api/forms?${queryString({ company })}`)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getForm = (company, form) => {
	return new Promise((resolve, reject) => {
		let data = { company, form }
		return axios.get(`${cms.baseURL}/api/forms/form?${queryString(data)}`)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const updateForm = (data) => {
	return new Promise((resolve, reject) => {
		return axios.put(`${cms.baseURL}/api/forms/form`, data)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const createForm = (data) => {
	return new Promise((resolve, reject) => {
		return axios.post(`${cms.baseURL}/api/forms`, data)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

export { createForm, getForms, getForm, updateForm }